import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';

@Component({
  selector: 'app-DataEntityLabAddress',
  templateUrl: './DataEntityLabAddress.component.html',
  styleUrls: ['./DataEntityLabAddress.component.css']
})
export class DataEntityLabAddressComponent implements OnInit {


  @Input() inner_Calibration_Device_Id:number=0
  @Input() inner_Calibration_Lab_Address:string=''

  @Output() outter_selected_Lab_Address = new EventEmitter<string>();

  Token: String = ''

  constructor(
    private Calibration_Service: CalibrationService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_LabAddress()
  }

  //#region LabAddress

  Shitch_LabAddress:boolean=true
  Datalist_LabAddress: Array<string> = []
  Read_LabAddress() {
    this.Calibration_Service.GetLabAddressCustomer(this.Token, this.inner_Calibration_Device_Id).subscribe(
      data => {
        this.Datalist_LabAddress=data
      },
      (error) => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  Shitch_LabAddress_click() {
    this.outter_selected_Lab_Address.emit('');
    this.Shitch_LabAddress = !this.Shitch_LabAddress
  }

  set_inner_Calibration_Lab_Address() {
    this.outter_selected_Lab_Address.emit(this.inner_Calibration_Lab_Address);

  }


  //#endregion


  
}
